import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc } from "firebase/firestore";

import { Frame, Loading, Header, ValidaUid } from "../components";
import { db } from "../config/firebase";

const Renovacao = () => {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  const [mostrarConfirmacao, setMostrarConfirmacao] = useState(false);

  const [modalMensagem, setModalMensagem] = useState({
    show: false,
    titulo: "",
    mensagem: "",
    variant: "primary",
    redirecionar: false,
  });

  const navigate = useNavigate();

  const aceitar = () => {
    navigate("../aceite");
  };

  const abrirModalMensagem = ({
    titulo,
    mensagem,
    variant = "primary",
    redirecionar = false,
  }) => {
    setModalMensagem({
      show: true,
      titulo,
      mensagem,
      variant,
      redirecionar,
    });
  };

  const fecharModalMensagem = () => {
    const deveRedirecionar = modalMensagem.redirecionar;

    setModalMensagem((estadoAtual) => ({
      ...estadoAtual,
      show: false,
    }));

    if (deveRedirecionar) {
      navigate("../home");
    }
  };

  const encerrar = async () => {
    if (!dados?.uid) {
      setMostrarConfirmacao(false);

      abrirModalMensagem({
        titulo: "Usuário não identificado",
        mensagem: "Não foi possível identificar o usuário.",
        variant: "danger",
        redirecionar: true,
      });

      return;
    }

    try {
      setSalvando(true);

      await setDoc(
        doc(db, "ebserh2026", dados.uid),
        {
          status: "c",
        },
        {
          merge: true,
        },
      );

      setMostrarConfirmacao(false);

      abrirModalMensagem({
        titulo: "Contrato encerrado",
        mensagem:
          "Contrato encerrado com sucesso!\n\nObrigado por utilizar os nossos serviços.",
        variant: "success",
        redirecionar: true,
      });
    } catch (error) {
      console.error("Erro ao encerrar contrato:", error);

      setMostrarConfirmacao(false);

      abrirModalMensagem({
        titulo: "Erro ao encerrar contrato",
        mensagem:
          "Não foi possível encerrar o contrato. Tente novamente em alguns instantes.",
        variant: "danger",
      });
    } finally {
      setSalvando(false);
    }
  };

  useEffect(() => {
    const buscarDados = async () => {
      try {
        const uid = await ValidaUid();

        if (!uid) {
          navigate("../home");
          return;
        }

        const snapshot = await getDoc(doc(db, "ebserh2026", uid));

        if (!snapshot.exists()) {
          navigate("../home");
          return;
        }

        const data = snapshot.data();

        if (data?.anoAtual !== "2025" || data?.status !== "a") {
          navigate("../home");
          return;
        }

        setDados({
          ...data,
          uid,
        });
      } catch (error) {
        console.error("Erro ao buscar dados da renovação:", error);
        navigate("../home");
      } finally {
        setLoading(false);
      }
    };

    buscarDados();
  }, [navigate]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      <Frame
        title="Renovação de Contrato"
        body={
          <div className="mx-auto px-1 py-2">
            <div className="d-flex justify-content-center gap-4 flex-wrap">
              <div className="mb-3">
                <div className="mb-3">
                  Para permanecer no serviço de fretamento, clique em
                  <strong> "Renovar contrato"</strong>, leia o contrato e
                  confirme a renovação.
                </div>
                <div className="mb-3">
                  Caso não tenha interesse em continuar utilizando o serviço,
                  clique em
                  <strong> "Encerrar contrato"</strong> e confirme a
                  solicitação.
                </div>

                <div className="alert alert-warning mb-0">
                  <strong>Aviso:</strong> Após a renovação, a mensalidade será
                  de
                  <strong> R$ 748,00</strong> e o saldo individual será
                  reajustado para
                  <strong> R$ 18,70</strong>.
                </div>
              </div>
              <Button
                variant="outline-danger"
                size="lg"
                className="px-4 py-3 fw-semibold"
                style={{ minWidth: "220px" }}
                onClick={() => setMostrarConfirmacao(true)}
                disabled={salvando}
              >
                Encerrar contrato
              </Button>

              <Button
                variant="primary"
                size="lg"
                className="px-4 py-3 fw-semibold"
                style={{ minWidth: "220px" }}
                onClick={aceitar}
                disabled={salvando}
              >
                Renovar contrato
              </Button>
            </div>
          </div>
        }
      />

      <Modal
        show={mostrarConfirmacao}
        onHide={() => {
          if (!salvando) {
            setMostrarConfirmacao(false);
          }
        }}
        centered
        backdrop={salvando ? "static" : true}
        keyboard={!salvando}
      >
        <Modal.Header closeButton={!salvando}>
          <Modal.Title>Confirmar encerramento</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-2 fw-semibold">
            Tem certeza que deseja encerrar seu contrato?
          </p>

          <p className="mb-0 text-muted">
            Esta ação cancelará a renovação do serviço.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setMostrarConfirmacao(false)}
            disabled={salvando}
          >
            Voltar
          </Button>

          <Button variant="danger" onClick={encerrar} disabled={salvando}>
            {salvando ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                  aria-hidden="true"
                />
                Encerrando...
              </>
            ) : (
              "Sim, encerrar contrato"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modalMensagem.show} onHide={fecharModalMensagem} centered>
        <Modal.Header
          closeButton
          className={
            modalMensagem.variant === "success"
              ? "bg-success text-white"
              : modalMensagem.variant === "danger"
                ? "bg-danger text-white"
                : ""
          }
        >
          <Modal.Title>{modalMensagem.titulo}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mb-0" style={{ whiteSpace: "pre-line" }}>
            {modalMensagem.mensagem}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant={modalMensagem.variant} onClick={fecharModalMensagem}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Renovacao;
